import moment from 'moment';
import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { MemoryRouter, Redirect, Route, Switch } from 'react-router';
import { ROBOT_ENVIRONMENT } from '../../config/constants';
import { WithRobotEnvironment } from '../../contexts/general/RobotEnvironmentContext';
import { WithPensionContext } from '../../contexts/pension-robot/PensionContext';
import { ExpensesSection } from './cocktail-filler-screen/ExpensesSection';
import { LegalSection } from './cocktail-filler-screen/LegalSection';
import { PensionAOWSection } from './cocktail-filler-screen/PensionAOWSection';
import { PensionGrossSection } from './cocktail-filler-screen/PensionGrossSection';
import { PensionSection } from './cocktail-filler-screen/PensionSection';
import { PersonalInfoSection } from './cocktail-filler-screen/PersonInfoSection';
import { ResultsSection } from './cocktail-filler-screen/ResultsSection';
import { SupplementSection } from './cocktail-filler-screen/SupplementSection';

moment.locale('nl');

const queryClient = new QueryClient();

export const PensionRobot: React.FC<{
    environment: ROBOT_ENVIRONMENT,
    userToken?: string
    googleAnalyticsCode?: string
}> = ({ environment, userToken, googleAnalyticsCode }) => {
    return (
        <div className="text-bnd-black-1 dark:text-white pension-robot text-base leading-normal min-h-screen text-left">
            <QueryClientProvider client={queryClient}>
                <WithRobotEnvironment environment={environment} userToken={userToken} googleAnalyticsCode={googleAnalyticsCode}>
                    <WithPensionContext>
                        <MemoryRouter>
                            <Switch>
                                <Route exact path="/legal">
                                    <LegalSection />
                                </Route>
                                <Route exact path="/personal">
                                    <PersonalInfoSection />
                                </Route>
                                <Route exact path="/expenses">
                                    <ExpensesSection />
                                </Route>
                                <Route exact path="/pension">
                                    <PensionSection />
                                </Route>
                                <Route exact path="/pension-partner">
                                    <PensionSection isPartnerSection/>
                                </Route>
                                <Route exact path="/pension-aow">
                                    <PensionAOWSection />
                                </Route>
                                <Route exact path="/pension-aow-partner">
                                    <PensionAOWSection isPartnerSection />
                                </Route>
                                <Route exact path="/pension-gross">
                                    <PensionGrossSection />
                                </Route>
                                <Route exact path="/pension-gross-partner">
                                    <PensionGrossSection isPartnerSection />
                                </Route>
                                <Route exact path="/supplement">
                                    <SupplementSection />
                                </Route>
                                <Route exact path="/supplement-partner">
                                    <SupplementSection isPartnerSection />
                                </Route>
                                <Route exact path="/results">
                                    <ResultsSection />
                                </Route>
                                <Route path="/">
                                    <Redirect to="/legal" />
                                </Route>
                            </Switch>
                        </MemoryRouter>
                    </WithPensionContext>
                </WithRobotEnvironment>
            </QueryClientProvider>
        </div>
    );
};
